import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import '../scss/main.scss';

var $ = require("jquery");

require('bootstrap/dist/js/bootstrap.bundle');

require('bootstrap-select/dist/js/bootstrap-select.min.js');

Storage.prototype.setObj = function (key, obj) {
  return this.setItem(key, JSON.stringify(obj));
};

Storage.prototype.getObj = function (key) {
  return JSON.parse(this.getItem(key));
};

document.onreadystatechange = function () {
  if (document.readyState == 'complete') {
    if (!$('#co2-footprint')[0].checkValidity()) $('#co2-footprint button[type="submit"]').attr('disabled', 'disabled');
    $('.co2-calc-select').on('click', function (e) {
      e.preventDefault();
      $('#co2-start, #co2-footprint-results').addClass('d-none');
      $($(this).attr('href')).removeClass('d-none');
      $("#co2-footprint-results").remove();
      initGoogleApi();
      scrollTo($($(this).attr('href')));
      history.replaceState({
        'page': 'link'
      }, "", $('#current-page-url').val());
    });
    $('#co2-footprint').on('change', 'select[name="transport"], .transport-select', function () {
      $('#transport-modal-' + $(this).val()).modal('show');

      if ($('#co2-footprint')[0].checkValidity()) {
        $('#co2-footprint button[type="submit"]').removeAttr('disabled');
      }
    });
    $('#co2-footprint > .modal select[name^="type"]').on('change', function () {
      var $engineOpt = $(this).closest('.modal').find('select[name^="engine"] option').addClass('d-none');
      filterEngineOpt($engineOpt, $('option', this));
    });
    $('.add-waypoint').on('click', function (e) {
      e.preventDefault();
      var waypointCount = $(this).prev('.route-box').find('.waypoint-group').length;
      var $waypoint = $($('#waypoint-template').html()).insertBefore($(this).prev('.route-box').find('.form-group').last());
      $waypoint.find('input').attr('name', 'waypoint[' + waypointCount + '][]').end().find('label a').one('click', function (e) {
        e.preventDefault();
        $waypoint.remove();
      }).end().find('.transport-select').attr('name', 'waypoint[' + waypointCount + '][]').selectpicker();

      if ($(this).closest('#co2-cost')[0]) {
        $waypoint.find('label').addClass('text-uppercase mb-0 pt-3').end().find('.form-group').remove();
      }

      var $input = $waypoint.find('.route-point');
      var point = new google.maps.places.Autocomplete($input[0], {// types: ['address']
      });
      point.addListener('place_changed', function () {
        setLatLng(point.getPlace(), $input, $input.closest('form'));
      });
    });
    $('.custom-checkbox input').on('change', function () {
      $('#steps-box [data-transport]').removeClass('checked active');
      $('.btn-next').attr('disabled', 'disabled');
      $('.co2-transport-substep').removeClass('checked active').each(function () {
        var $step = $(this);
        var check = false;
        $('.custom-checkbox input').filter(':checked').each(function () {
          if (new RegExp("(?:^|[^-\\w])(" + $(this).val() + ")(?:[^-\\w]|$)", "g").test($step.data('transport'))) {
            check = true;
            $('#steps-box [data-transport="' + $step.data('transport') + '"]').addClass('checked'); // $('.btn-next').removeAttr('disabled');
          }

          $('.btn-next').removeAttr('disabled');
        });
        if (check) $step.addClass('checked');
      });
      $('.co2-transport-substep.checked').first().addClass('active');
    });
    $('.step-btn').on('click', function () {
      if ($(this).hasClass('btn-next')) {
        if (!$('#co2-cost')[0].checkValidity()) {
          $('#co2-cost button[type="submit"]').trigger('click');
        } else {
          if ($('.co2-substep').not('.d-none').find('.co2-transport-substep.active').filter(':visible')[0] && $('.co2-transport-substep.active').nextAll('.checked')[0]) {
            $('#steps-box [data-transport="' + $('.co2-transport-substep.active').data('transport') + '"]').addClass('completed');
            $('.co2-transport-substep.active').removeClass('active').nextAll('.checked').first().addClass('active');
          } else {
            $('#steps-box .active').toggleClass('active completed').next().addClass('active');
            $('.co2-substep').not('.d-none').addClass('d-none').next().removeClass('d-none');

            if (!$('.co2-substep').not('.d-none')[0] || $('.custom-checkbox input').filter(':checked')[0] && !$('.co2-substep').not('.d-none').find('.co2-transport-substep').filter(':visible')[0]) {
              $('#main-form-container').addClass('d-none');
              scrollTo($('.header-main'));
              $('#co2-cost button[type="submit"]').trigger('click');
            }
          }
        }
      } else {
        if ($('.co2-substep').not('.d-none').find('.co2-transport-substep.active').filter(':visible')[0] && $('.co2-transport-substep.active').prevAll('.checked')[0]) {
          $('.co2-transport-substep.active').removeClass('active').prevAll('.checked').first().addClass('active');
          $('#steps-box [data-transport="' + $('.co2-transport-substep.active').data('transport') + '"]').removeClass('completed');
        } else {
          $('#steps-box .active').removeClass('active').prev().toggleClass('completed active');

          if ($('.co2-substep').not('.d-none')[0]) {
            $('.co2-substep').not('.d-none').addClass('d-none').prev().removeClass('d-none');
          } else {
            $('.co2-substep.d-none').last().removeClass('d-none');
          }
        }
      }

      $('.step-btn').removeAttr('disabled');

      if ($('#steps-box .active').index() == 0) {
        $('.btn-back').attr('disabled', 'disabled');
      } else if ($('#steps-box .active').index() == 3 || $('.custom-checkbox').filter(':visible')[0] && !$('.custom-checkbox input').filter(':checked')[0]) {
        $('.btn-next').attr('disabled', 'disabled');
      }

      if ($('.co2-step').filter(':visible')[0]) scrollTo($('.co2-step').filter(':visible').first());
    });
    $('.co2-transport-substep select[name$="[vehicle_segment]"]').on('change', function () {
      var $engineOpt = $(this).closest('.co2-transport-substep').find('select[name$="[drive_type]"] option').addClass('d-none');
      filterEngineOpt($engineOpt, $('option', this));
    });
    $('#co2-cost').on('submit', function (e) {
      if (!$('.custom-checkbox input').filter(':checked')[0]) {
        e.preventDefault();
      }
    });
    if ($('#co2-cost-results')[0]) initGoogleApi();
    $('body').on('click', '.popup-content a', function (e) {
      e.preventDefault();
      $('#routes-box').addClass('transform');
    });
    $('.single-route-details > a').on('click', function (e) {
      e.preventDefault();
      $('#routes-box').removeClass('transform');
    });
    $('#bike-drive-type-select').on('change', function () {
      if ($(this).val() != 'Ohne Antrieb') {
        $('#bike-usage-box').removeClass('d-none');
      } else {
        $('#bike-usage-box').addClass('d-none');
      }
    });
    $('.opnv-ticket-type').on('change', function () {
      if ($(this).val() == 'single_ticket') {
        $('#opnv-ticket-price').removeClass('d-none');
      } else {
        $('#opnv-ticket-price').addClass('d-none');
      }
    });
    $('.car-engine').on('change', function () {
      if ($(this).val() == 'Plug-In-Hybrid') {
        $('.usage-phev').removeClass('d-none');
        $('.usage-non-phev').addClass('d-none');
      } else {
        $('.usage-phev').addClass('d-none');
        $('.usage-non-phev').removeClass('d-none');
      }
    });
    var radioButtons = document.querySelectorAll('input[name="details[7][ticket_type]"]');
    var lastChecked = null;
    radioButtons.forEach(function (radio) {
      radio.addEventListener('mousedown', function () {
        lastChecked = this.checked ? this : null;
      });
      radio.addEventListener('click', function () {
        if (lastChecked === this && this.checked) {
          this.checked = false;
          lastChecked = null;

          if ($(this).val() === 'single_ticket') {
            $('#opnv-ticket-price').addClass('d-none');
          }
        } else {
          lastChecked = this;
        }
      });
    });
  }
};

function filterEngineOpt($engineOpt, $opt) {
  $.each($opt.filter(':selected').data('available').split(','), function (i, val) {
    var type = val.trim();
    $engineOpt.filter(function () {
      return $(this).val() != "";
    }).each(function () {
      if ($(this).val().trim() === type) {
        $(this).removeClass('d-none');
      }
    });
  });
}

function initGoogleApi() {
  $.getScript('https://maps.googleapis.com/maps/api/js?key=' + $('#google-maps-key').val() + '&libraries=geometry,places&language=de', function (data, textStatus, jqxhr) {
    if (jqxhr.status == 200) {
      console.info('google maps API loaded');
      if ($('#co2-cost-results')[0]) $('#loading-progress').text('75%');
      $('.route-point').filter(':visible').each(function () {
        var $input = $(this);
        var point = new google.maps.places.Autocomplete($input[0], {// componentRestrictions: { country: "de" },
          // types: ['address']
        });
        point.addListener('place_changed', function () {
          setLatLng(point.getPlace(), $input, $input.closest('form'));
        });
        $input.siblings('label').find('a').one('click', function (e) {
          e.preventDefault();
          $input.closest('.waypoint-group').remove();
        });
      });
      if ($('#map-box')[0]) initMap();
    }
  });
}

function setLatLng(place, $input, $form) {
  if (!place.geometry) {
    window.alert("No details available for input: '" + place.name + "'");
  } else {
    var lat = place.geometry.location.lat();
    var lng = place.geometry.location.lng();
    $input.next().val(lat + '|' + lng);
  }

  $input.on('keydown', function (e) {
    var code = e.keyCode || e.which;

    if (code == 13) {
      e.preventDefault();
    }
  });

  if ($form[0].checkValidity()) {
    $('button[type="submit"]', $form).removeAttr('disabled');
  }
}

var Popup;

function initMap() {
  var startPoint = $('#map-start-point').val().split("|");
  var endPoint = $('#map-end-point').val().split("|");
  var start = new google.maps.LatLng(startPoint[0] || 0, startPoint[1] || 0),
      end = new google.maps.LatLng(endPoint[0] || 0, endPoint[1] || 0),
      map_canvas = $('#map-box')[0],
      map_options = {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoom: 14,
    center: start,
    maxZoom: 18,
    minZoom: 5,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP
    },
    disableDefaultUI: true,
    gestureHandling: 'cooperative',
    backgroundColor: '#102542',
    styles: [{
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "administrative",
      "elementType": "labels.text",
      "stylers": [{
        "color": "#a5c6d9"
      }]
    }, {
      "featureType": "administrative",
      "elementType": "labels.text.stroke",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "administrative.land_parcel",
      "elementType": "labels",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [{
        "color": "#00508c"
      }]
    }, {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#00508c"
      }]
    }, {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{
        "visibility": "simplified"
      }]
    }, // {"featureType":"road","elementType": "labels","stylers": [{"visibility": "off"}]},
    // {"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},
    {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#102542"
      }, {
        "visibility": "simplified"
      }]
    }, // {"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"off"}]},
    {
      "featureType": "road.arterial",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#102542"
      }]
    }, // {"featureType":"road.arterial","elementType":"labels","stylers":[{"visibility":"off"}]},
    // {"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},
    {
      "featureType": "road.local",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#102542"
      }]
    }, {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [{
        "color": "#102542"
      }]
    }, {
      "featureType": "transit",
      "elementType": "labels",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "transit",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#102542"
      }]
    }, {
      "featureType": "water",
      "elementType": "all",
      "stylers": [{
        "color": "#00508c"
      }, {
        "lightness": 10
      }, {
        "visibility": "on"
      }]
    }, {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#00508c"
      }, {
        "lightness": 10
      }]
    }, {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "road",
      "elementType": "labels.text",
      "stylers": [{
        "color": "#a5c6d9"
      }]
    }, {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [{
        "visibility": "off"
      }]
    }]
  };
  var map = new google.maps.Map(map_canvas, map_options);
  var markerInfo = new google.maps.InfoWindow(); // -------------------------------------------------------

  var Popup = /*#__PURE__*/function (_google$maps$OverlayV) {
    _inherits(Popup, _google$maps$OverlayV);

    var _super = _createSuper(Popup);

    function Popup(position, content) {
      var _this;

      _classCallCheck(this, Popup);

      _this = _super.call(this);

      _defineProperty(_assertThisInitialized(_this), "position", void 0);

      _defineProperty(_assertThisInitialized(_this), "containerDiv", void 0);

      _this.position = position;
      content.classList.add("popup-bubble"); // This zero-height div is positioned at the bottom of the bubble.

      var bubbleAnchor = document.createElement("div");
      bubbleAnchor.classList.add("popup-bubble-anchor");
      bubbleAnchor.appendChild(content); // This zero-height div is positioned at the bottom of the tip.

      _this.containerDiv = document.createElement("div");

      _this.containerDiv.classList.add("popup-container");

      _this.containerDiv.appendChild(bubbleAnchor); // Optionally stop clicks, etc., from bubbling up to the map.


      Popup.preventMapHitsAndGesturesFrom(_this.containerDiv);
      return _this;
    }
    /** Called when the popup is added to the map. */


    _createClass(Popup, [{
      key: "onAdd",
      value: function onAdd() {
        this.getPanes().floatPane.appendChild(this.containerDiv);
      }
      /** Called when the popup is removed from the map. */

    }, {
      key: "onRemove",
      value: function onRemove() {
        if (this.containerDiv.parentElement) {
          this.containerDiv.parentElement.removeChild(this.containerDiv);
        }
      }
      /** Called each frame when the popup needs to draw itself. */

    }, {
      key: "draw",
      value: function draw() {
        var divPosition = this.getProjection().fromLatLngToDivPixel(this.position); // Hide the popup when it is far out of view.

        var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? "block" : "none";

        if (display === "block") {
          this.containerDiv.style.left = divPosition.x + "px";
          this.containerDiv.style.top = divPosition.y + "px";
        }

        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display;
        }
      }
    }]);

    return Popup;
  }(google.maps.OverlayView); // -------------------------------------------------------


  var directionsBound = new google.maps.LatLngBounds();
  addMarker(start, $('#map-start').val(), map, directionsBound);
  addMarker(end, $('#map-end').val(), map, directionsBound);
  var waypoints = [];
  $('input.map-waypoint').each(function () {
    var val = $(this).val().split("|");
    waypoints.push({
      location: new google.maps.LatLng(val[0], val[1]),
      stopover: false
    });
    directionsBound.extend(new google.maps.LatLng(val[0], val[1]));
  });
  $('.single-route').each(function () {
    var $routeBox = $(this);
    var route = $routeBox.data('name');
    var routePath = google.maps.geometry.encoding.decodePath($('input', $routeBox).val());
    window[route] = new google.maps.Polyline({
      map: map,
      path: routePath,
      clickable: false,
      strokeColor: '#eb6c43',
      strokeOpacity: $routeBox.hasClass('active') ? 1 : 0.4,
      zIndex: $routeBox.hasClass('active') ? 1 : 0
    });
    window[route + '-popup'] = new Popup( // routePath[parseInt(routePath.length/2)*1],
    routePath[parseInt(routePath.length / 85) * 1], $('.popup-content', $routeBox)[0]);
    directionsBound.extend(routePath[parseInt(routePath.length / 2) * 1]);
    var routePoints = []; // $routeBox.next('.single-route-details').find('input').slice(1).each(function(){

    $routeBox.next('.single-route-details').find('.route-waypoint input').each(function () {
      var pointName = $(this).parent().text();
      var prevIcon = $(this).parent().prevAll('div').eq(0).find('img');
      var nextIcon = $(this).parent().next('div').find('img');

      if (typeof prevIcon[0] != 'undefined') {
        prevIcon = prevIcon[0].outerHTML;
      }

      if (typeof nextIcon[0] != 'undefined') {
        nextIcon = nextIcon[0].outerHTML;
      }

      var val = $(this).val().split(",");
      var point = new google.maps.Marker({
        map: $routeBox.hasClass('active') ? map : null,
        draggable: false,
        clickable: true,
        animation: google.maps.Animation.DROP,
        position: new google.maps.LatLng(val[0], val[1]),
        icon: {
          url: $('#map-point').val(),
          anchor: new google.maps.Point(7, 7)
        }
      });
      routePoints.push(point);
      point.addListener("click", function () {
        markerInfo.setContent('<div class="marker-info-box">' + pointName + '<div>' + prevIcon + ' <span></span> ' + nextIcon + '</div></div>');
        markerInfo.setZIndex(3);
        markerInfo.open(map, point);
        map.setZoom(15);
        map.setCenter(point.getPosition());
      });
    });
    window[route + '-point'] = routePoints;

    if ($routeBox.hasClass('active')) {
      window[route + '-popup'].setMap(map);
    }
  }); // map.fitBounds(directionsBound);

  $('.single-route a').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.single-route').addClass('active').siblings().removeClass('active');
    $('.single-route').each(function () {
      var $routeBox = $(this);
      var route = $routeBox.data('name');
      var stroke = {
        strokeColor: '#eb6c43',
        strokeOpacity: 0.4,
        zIndex: 0
      };
      window[route + '-popup'].setMap(null);

      if ($routeBox.hasClass('active')) {
        window[route + '-popup'].setMap(map);
        stroke = {
          strokeColor: '#eb6c43',
          strokeOpacity: 1,
          zIndex: 1
        };
      }

      window[route].setOptions(stroke);
      window[route].setMap(map);
      $.each(window[route + '-point'], function (index, marker) {
        marker.setMap($routeBox.hasClass('active') ? map : null);
      });
    });
    $('#routes-box').addClass('transform'); // map.fitBounds(directionsBound);
  });
  google.maps.event.addDomListener(window, 'resize', function () {
    window.setTimeout(function () {// map.fitBounds(directionsBound);
    }, 500);
  });
  $('body, html').animate({
    scrollTop: $('#co2-cost-results-loading').offset().top - 68
  }, {
    duration: 200,
    complete: function complete() {
      $('#co2-cost-results-loading').slideUp(500, function () {
        $('body, html').animate({
          scrollTop: $('#co2-cost-results').offset().top - $('#navigation-main').innerHeight()
        }, {
          duration: 200
        });
      });
    }
  });
}

function addMarker(position, icon, map, directionsBound) {
  new google.maps.Marker({
    map: map,
    draggable: false,
    clickable: false,
    animation: google.maps.Animation.DROP,
    position: position,
    icon: {
      url: icon,
      anchor: new google.maps.Point(20, 26)
    }
  });
  directionsBound.extend(position);
}

function scrollTo($element) {
  $('body, html').animate({
    scrollTop: $element.offset().top - $('.header-main').height()
  }, {
    duration: 200
  });
}